import { Component, OnInit } from "@angular/core";
import { Biller } from "../../../../core/models/users/billers/billerDto";
import { Collector } from "../../../../core/models/users/collectors/collectorDto";
import { UserHeader } from "../../../../core/models/users/user-header";
import { CommonModule } from "@angular/common";
import { AddEditHeaderComponent } from "../add-edit-header/add-edit-header.component";
import { BillerListingComponent } from "../biller-listing/biller-listing.component";
import { CollectorListingComponent } from "../collector-listing/collector-listing.component";
import { BillerCollectorService } from "../../../../core/services/biller-collector-service";

@Component({
  selector: "jni-add-edit-biller-collector",
  templateUrl: "./add-edit-biller-collector.component.html",
  imports: [
    CommonModule,
    AddEditHeaderComponent,
    BillerListingComponent,
    CollectorListingComponent,
  ],
  styleUrls: ["./add-edit-biller-collector.component.scss"],
})
export class AddEditBillerCollectorComponent implements OnInit {
  showSmallLoader = false;
  billerList: Biller[] = [];
  collectorList: Collector[] = [];
  userHeaderInfo: UserHeader = {} as UserHeader;

  constructor(private _billerCollectorService: BillerCollectorService) {}

  ngOnInit(): void {
    this.reloadUserLists();
  }

  updateBiller(event: UserHeader) {
    this.userHeaderInfo = event;
  }

  updateCollector(event: UserHeader) {
    this.userHeaderInfo = event;
  }

  getLoaderStatus(status: boolean) {
    this.showSmallLoader = status;
  }

  getAllBillers() {
    this.showSmallLoader = true;
    this._billerCollectorService.getAllBiller().subscribe({
      next: res => {
        if (res.data) {
          if (res?.data?.length > 0) {
            this.billerList = res.data;
          }
        }
      },
      error: () => {
        this.showSmallLoader = false;
      },
    });
  }

  getAllCollectors() {
    this.showSmallLoader = true;
    this._billerCollectorService.getAllCollector().subscribe({
      next: res => {
        if (res.data) {
          if (res?.data?.length > 0) {
            this.collectorList = res.data;
          }
        }
      },
      error: () => {
        this.showSmallLoader = false;
      },
    });
  }

  reloadUserLists() {
    this.getAllBillers();
    this.getAllCollectors();
  }
}
